var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/*
 * @Author: 朱璐
 * @Date: 2022-10-28 14:39:44
 * @Description: 顶部带语言切换header
 */
import { classNames } from '@common/application/utils/classnames';
import { IconArrow } from '@common/components/icon/arrow';
import env from '@common/constants/env';
import { LANGUAGE_NAMES, LANGUAGE_OPTIONS } from '@common/constants/language';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { Dropdown } from '../dropdown';
export const LanguageChange = ({ className }) => {
    const router = useRouter();
    const [locale, setLocale] = useState(env.DEFAULT_LOCAL);
    useEffect(() => {
        const lng = (router === null || router === void 0 ? void 0 : router.locale) || env.DEFAULT_LOCAL;
        setLocale(lng);
    }, [router.locale]);
    function createPath(lng) {
        const { href, origin } = window.location;
        const basePath = `${origin}/${lng}`;
        const originPath = href.replace(origin, '').replace(/^\/?(tc|en|cn)(\/|[^.]*)/, '');
        return originPath ? `${basePath}/${originPath}` : basePath;
    }
    const changeLocal = (data) => __awaiter(void 0, void 0, void 0, function* () {
        if (locale !== data.id) {
            setLocale(data.id);
            router.push(createPath(data.id));
        }
    });
    return (_jsx(Dropdown, Object.assign({ data: LANGUAGE_OPTIONS, value: locale, placement: "bottomCenter", onChange: changeLocal, className: 'mobile:w-full' }, { children: _jsxs("div", Object.assign({ className: classNames('flex items-center cursor-pointer', className) }, { children: [_jsx("div", Object.assign({ className: "text-black-2 pl-4 pr-1" }, { children: LANGUAGE_NAMES[locale] })), _jsx(IconArrow, { className: "w-4.5 h-4.5 rotate-180" })] })) })));
};
